import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import IconsStore from '../../../../reusable/IconsStore/IconsStore';
import { IconsList } from '../../../../reusable/IconsStore/IconsList';

import './SpeechToTextDeleteSubtitleDialog.scss';

type SpeechToTextDeleteTranscriptionDialogProps = {
	isOpen: boolean;
	onClose: () => void;
	onDeleteTranscription: () => void;
};

const SpeechToTextDeleteTranscriptionDialog = ({
	isOpen,
	onClose,
	onDeleteTranscription,
}: SpeechToTextDeleteTranscriptionDialogProps) => {
	const { t } = useTranslation();
	return (
		<Dialog
			fullWidth
			maxWidth={'sm'}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			open={isOpen}
			className="confirmationPopup"
		>
			<DialogTitle className="dialogTitle" disableTypography>
				<Typography variant="h6">
					{t('MEDIA_LIBRARY_MEDIA_INSPECT_PAGE_S2T_HEADER_DELETE_TRANSCRIPTION') + '?'}
				</Typography>
				<IconButton onClick={onClose}>
					<Close />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					<div className="dialogContentWrapper">
						<label>{t('This will permanently delete the selected transcription.')}</label>
						<br></br>
						<label>{t('COMMON_DELETE_CONFIRMATION_SINGLE')}</label>
					</div>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<div className="dialogActionsWrapper">
					<div className="dialogBoxInternalBlock deleteUserBtnContentWrapper">
						<Button variant="contained" className="defaultActionBtn neutralBtn" onClick={onClose}>
							{t('BACK')}
						</Button>
						<Button
							variant="contained"
							className="defaultActionBtn deleteButtonWithIcon"
							onClick={onDeleteTranscription}
						>
							<IconsStore iconName={IconsList.TRASHCAN} />
							{t('COMMON_DELETE')}
						</Button>
					</div>
				</div>
			</DialogActions>
		</Dialog>
	);
};

export default SpeechToTextDeleteTranscriptionDialog;
